import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteObjectiveStrPanel } from './StrPanel';
import { DBCheckBoxObjective, AddButton } from '_components';
import { StrComments } from './StrComments';
import { StrengthHandTemplate } from './StrengthHandTemplate';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
class PatientCareCenterNoteObjectiveStr extends React.Component {

    updateValue(colName){
        this.props.updateDefaultObjWFL(this.props.noteType, colName, this.props.pk);
    }


    render() {
        return (
            <span>
                {this.props.panels.length > 0 &&
                    <PatientCareCenterNoteSection id='obj_str' name='Strength' level={5}>
                        <div className={styles.row}>
                            <div className={styles.flag} />
                            <DBCheckBoxObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='STNO'
                                entityKeyValue={this.props.stno}
                                field='STNOTTESTED'
                                className={styles.checkbox}
                                label='Not tested at this time'
                            />
                        </div>

                        {!this.props.notTested &&
                            <span>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.str_header}>Strength</div>
                                </div>

                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.r_header}>R</div>
                                    <div className={styles.c_header} />
                                    <div className={styles.l_header}>L</div>
                                </div>
                                <div className={styles.row}>
                                    <div className={styles.flag} />
                                    <div className={styles.label} />
                                    <div className={styles.r_header}><AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('STRR')} /></div>
                                    <div className={styles.c_header}>{this.props.hasCenterValues ? <AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('STR')} />:""}</div>
                                    <div className={styles.l_header}><AddButton size='extra-small' title={'WFL'} onClick={() => this.updateValue('STRL')} /></div>
                                </div>

                                {
                                    Object.keys(this.props.panels)
                                        .map(key => {
                                            return (<PatientCareCenterNoteObjectiveStrPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} />);
                                        })

                                }
                            </span>
                        }
                        <StrComments />
                        {this.props.isHandSelected &&
                            <StrengthHandTemplate />
                        }

                    </PatientCareCenterNoteSection>
                }
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        updateDefaultObjWFL: bindActionCreators(noteActions.updateDefaultObjWFL, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let notTested = state.entities.notes.PTOBJECTIVESTR[stno].STNOTTESTED;

    let isHandSelected = Object.keys(state.entities.notes.PTOBJECTIVETEMPLATESXREF)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBEVNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 16) ||
                (noteType !== 1 && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBNTNO === pk && state.entities.notes.PTOBJECTIVETEMPLATESXREF[key].OBTENO == 16)
        }).length > 0 ? true : false;
    let panels= getPanels(noteId, 'Strength');
    let hasCenterValues = panels.some(x => x.MOPMPTNO === 1);

    return {
        noteId: noteId,
        panels: panels,
        stno: stno,
        notTested: notTested,
        isHandSelected,
        noteType,
        pk,
        hasCenterValues
    };
}

const connectedPatientCareCenterNoteObjectiveStr = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveStr);
export { connectedPatientCareCenterNoteObjectiveStr as PatientCareCenterNoteObjectiveStr };

